/**
 * Share Everywhere — extended share targets for the World Cup launch.
 * Pure helper: returns deep-links / fallbacks for the channels creators
 * actually use (WhatsApp, X, Telegram, Discord, Facebook, Email) plus
 * copy-to-clipboard fallbacks for TikTok and Reels (which don't accept
 * external share URLs).
 */
export type ShareChannel =
  | "whatsapp"
  | "x"
  | "telegram"
  | "discord"
  | "facebook"
  | "email"
  | "tiktok"
  | "reels"
  | "copy";

export interface ShareTarget {
  id: ShareChannel;
  label: string;
  emoji: string;
  href?: string;
  copyOnly?: boolean;
}

export function buildShareEverywhere(url: string, message: string): ShareTarget[] {
  const enc = encodeURIComponent;
  const text = `${message} ${url}`;
  return [
    { id: "whatsapp", label: "WhatsApp", emoji: "💬", href: `https://wa.me/?text=${enc(text)}` },
    { id: "x", label: "X", emoji: "𝕏", href: `https://twitter.com/intent/tweet?text=${enc(message)}&url=${enc(url)}` },
    { id: "telegram", label: "Telegram", emoji: "✈️", href: `https://t.me/share/url?url=${enc(url)}&text=${enc(message)}` },
    { id: "facebook", label: "Facebook", emoji: "f", href: `https://www.facebook.com/sharer/sharer.php?u=${enc(url)}` },
    { id: "discord", label: "Discord", emoji: "🎮", copyOnly: true },
    { id: "tiktok", label: "TikTok", emoji: "🎵", href: "https://www.tiktok.com/upload", copyOnly: true },
    { id: "reels", label: "Reels", emoji: "📸", href: "https://www.instagram.com/", copyOnly: true },
    { id: "email", label: "Email", emoji: "✉️", href: `mailto:?subject=${enc("VerseSport")}&body=${enc(`${message}\n\n${url}`)}` },
  ];
}

export async function copyShare(url: string, message: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(`${message} ${url}`);
    return true;
  } catch {
    return false;
  }
}